<template>
  <div>
    <div class="d-flex justify-content-center my-4">
      <div>
        <img src="@/pages/dashboard/userwizard/assets/clipboard.svg" width="64" height="64" class="filter_green">
      </div>
    </div>
    <div class="mx-auto text-center" style="max-width: 400px">
      <div style="line-height: 1.2em">
        <h4 class="text-white-in-dark-mode">
        به پی استار خوش آمدید.
        </h4>
        <br>
        <h5 class="mt-1 text-white-in-dark-mode">
        جهت احراز هویت و ثبت درگاه پرداخت کلیک کنید.
        </h5>
      </div>
    </div>
    <div class="form-group" v-if="current_user.status == userStatus.AUTHORIZATION_DOCUMENTS_REJECTED">
      <label for="rejected_status_description">
          {{ $t('label.auth_documentation_rejection_reason') }}
      </label>
      <textarea
        class="form-control no-resize"
        rows="6"
        id="rejected_status_description"
        name="rejected_status_description"
        v-model="current_user.rejected_status_description"
        disabled>
      </textarea>
    </div>
    <div class="d-flex justify-content-center mt-4">
      <button
        type="button"
        class="btn btn-success px-4 py-3"
        style="border-radius: 10px"
        @click="++wizard.current_step"
      >
        شروع فرآیند
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { userStatusStr, userStatus } from '@/constants/userStatus'

export default {
  props: {
    wizard: Object,
  },
  computed: {
    ...mapGetters('user', [
      'current_user'
    ])
  },
  data() {
    return {
      userStatus: userStatus,
    }
  }
};
</script>

<style scoped>
.filter_green {
  filter: invert(68%) sepia(25%) saturate(7218%) hue-rotate(130deg) brightness(91%) contrast(101%);
}
</style>